import { useContext, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { ToolsContext, ToolsDispatchContext, mainToolset } from "../../ToolsContext";
import { useNewGtfsStop } from "../../Queries";
import { useGtfsSuggestNewId } from "../../Queries";
import { OverlayContext } from "../../OverlaysContext";
import { NewStopForm } from "./NewStopForm";

export function NewStopDialog({visible, stopLocation, onHide}) {
    const tool = useContext(ToolsContext);
    const {status: defaultIdStatus, data: defaultId} = useGtfsSuggestNewId('stops');  
    const toolDispatch = useContext(ToolsDispatchContext);
    const handleOverlay = useContext(OverlayContext);  
    const newStopMutation = useNewGtfsStop();
    const [values, setValues] = useState({
        stop_id: '',
        stop_name: '',
        unnamed_stop_nr: 1,
        stop_name_placeholder: 'Przystanek bez nazwy ',
        validation_errors: {
            stop_id: false,
            stop_name: false
        }
    });

    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {handleSendData()}} autoFocus />
        </div>
    );

    function handleChangeID(e) {
        setValues({...values, stop_id: e.target.value});
    }

    function handleChangeStopName(e) {
        setValues({...values, stop_name: e.value});
    }


    async function handleSendData() {
        const data = {
          fields: {
            stop_id: (values.stop_id) ? values.stop_id : defaultId,
            stop_name: (values.stop_name) ? values.stop_name : values.stop_name_placeholder + values.unnamed_stop_nr,
            stop_lat: stopLocation.lat,
            stop_lon: stopLocation.lng
          }
        }
    
        try {
          const mutation = await newStopMutation.mutateAsync(data);
          if (values.stop_name === '') setValues({...values, unnamed_stop_nr: values.unnamed_stop_nr + 1})
          onHide();
          // po udanym dodaniu przystanku otwórz go w edytorze
          toolDispatch({
            type: 'changed',
            newTool: {
              ...mainToolset.tools.stopsTool,
              selection: data.fields.stop_id, // zaznacz przystanek na mapie
              propertyEditor: {   // i wyświetl w edytorze
                edit: data.fields
              }
            },
          });
          
        } catch(error) {
          const errorCode = error.message.slice(0,3);  
          if(errorCode == '422') {
            //obsługa błędów walidacji
            let updatedValidationErrors = {};
            let propertyNames = Object.keys(error.cause.validation);
            propertyNames.forEach((value) => {
              messages = Object.values(error.cause.validation[value]).join(', ');
              updatedValidationErrors[value] = messages;
            })
            setValues({
              ...values,
              validation_errors: {
                ...updatedValidationErrors
              }
            })
          } else {
            //obsługa wszystkich pozostałych błędów
            handleOverlay('toast', {
              severity: "error",
              summary: 'Błąd ' + errorCode,
              detail: error.message
            })
          } 
        }   
      }    

    return (
        <Dialog header="Nowy przystanek" 
                footer={dialogFooterContent} 
                visible={visible} 
                style={{ width: '50vw', maxWidth: '500px' }}  
                breakpoints={{ '960px': '75vw', '641px': '100vw' }} 
                onHide={onHide}
        >
            <div className="m-0">
                {
                (defaultIdStatus === 'success' || defaultIdStatus === 'error') 
                ? 
                    <NewStopForm 
                        values={{
                            ...values,
                            stop_id: (values.stop_id) ? values.stop_id : defaultId,
                            stop_name_placeholder: values.stop_name_placeholder + values.unnamed_stop_nr
                        }} 
                        onChangeStopId={handleChangeID} 
                        onChangeStopName={handleChangeStopName}
                    /> 
                : 
                    <ProgressSpinner />
                }
            </div>
        </Dialog>
    )
}